import {useState} from 'react';
import {getPublicCBStandards} from 'api/certification-bodies';
import {alertByError} from 'utils/alerts';

function useGetCBStandards(cbId, abId) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});

  async function getData() {
    setIsLoading(true);
    try {
      const {data, meta} = await getPublicCBStandards(cbId, {
        accreditation_bodies_id: abId,
        limit: -1,
      });

      setData(data);
      setMeta(meta);
    } catch (e) {
      alertByError(e);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    meta,
    data,
    isLoading,
    reload: getData,
  };
}

export default useGetCBStandards;
